import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { FormGroup, Checkbox, ControlLabel } from "react-bootstrap";

import { validateCheckOnlyModified } from "./SettingsValue";

const BoolControl = props => (
	<FormGroup validationState={validateCheckOnlyModified(props.local, props.prop)}>
		<ControlLabel>
			<FormattedMessage id={props.i18n_key} />
		</ControlLabel>
		<Checkbox name={props.prop} checked={props.local[props.prop].value}
			onChange={e => {
				/* e.value is "on" oder "off". Das wollen wir hier aber nicht haben,
				 * sonder lieber den Wert von e.target.checked. Deswegen die benötigten
				 * Felder im Event nachbilden, und den callback mit diesem neuen "Event"
				 * aufrufen.
				 */
				let e2 = {
					target: {
						name: e.target.name,
						value: e.target.checked
					}
				};
				props.handleChange(e2);
			}} />
	</FormGroup>
);

BoolControl.propTypes = {
	i18n_key: PropTypes.string.isRequired,
	prop: PropTypes.string.isRequired,
	local: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired
};

export default BoolControl;
